import styled from "styled-components";
import ProductGrid from "../components/ProductGrid";
import CTABanner from "../components/CTABanner";
import Reveal from "../components/Reveal";
import { Container, Section, Eyebrow } from "../components/ui";
import config from "../config";

export default function Products() {
  return (
    <>
      <Top>
        <Container>
          <Reveal>
            <Eyebrow>Produktet</Eyebrow>
            <H1>Tetë probleme, tetë zgjidhje</H1>
            <P>
              Të gjithë inhalatorët janë me vajra esencialë 100% organikë dhe
              prodhohen në Zvicër. {config.price}, {config.shipping.toLowerCase()},
              dhe {config.bundle.toLowerCase()}.
            </P>
          </Reveal>
        </Container>
      </Top>

      <Section $tight>
        <Container>
          <ProductGrid />
        </Container>
      </Section>

      <CTABanner />
    </>
  );
}

const Top = styled.header`
  padding: 148px 0 8px;

  ${({ theme }) => theme.bp.md} {
    padding: 190px 0 16px;
  }
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.size.h1};
  max-width: 14ch;
  margin-bottom: 22px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => theme.size.lg};
  max-width: 50ch;
`;
